import React from 'react';
import { cn } from '@/lib/utils';
import { STATUS_TOOLTIPS } from '../constants';
import type { RecipientStatusFilter } from '../types';
import { InfoTooltip } from './InfoTooltip';

interface StatusFilterButtonsProps {
  value: RecipientStatusFilter;
  onChange: (_value: RecipientStatusFilter) => void;
}

const FILTERS: { value: RecipientStatusFilter; label: string }[] = [
  { value: 'todos', label: 'Todos' },
  { value: 'ativo', label: 'Ativos' },
  { value: 'pendente', label: 'Pendentes' },
];

export const StatusFilterButtons: React.FC<StatusFilterButtonsProps> = ({
  value,
  onChange,
}) => (
  <div className="inline-flex h-9 shrink-0 items-center">
    {FILTERS.map((filter, index) => {
      const isActive = value === filter.value;
      const isFirst = index === 0;
      const isLast = index === FILTERS.length - 1;
      const tooltip =
        filter.value === 'ativo' || filter.value === 'pendente'
          ? STATUS_TOOLTIPS[filter.value]
          : null;

      return (
        <button
          key={filter.value}
          type="button"
          onClick={() => onChange(filter.value)}
          className={cn(
            '-ml-px inline-flex h-9 items-center justify-center gap-2 border border-[#E5E5E5] px-3 text-sm font-medium leading-5 text-[#0A0A0A] first:ml-0',
            isFirst && 'rounded-l-lg',
            isLast && 'rounded-r-lg',
            !isFirst && !isLast && 'rounded-none',
            isActive ? 'bg-[#F5F5F5]' : 'bg-white'
          )}
        >
          {tooltip ? (
            <InfoTooltip text={tooltip} iconClassName="h-4 w-4 text-[#0A0A0A]" />
          ) : null}
          {filter.label}
        </button>
      );
    })}
  </div>
);
